module.exports = __webpack_public_path__ + "media/images/ceremony/ceremony-wedding-dress-logo-3-841e028c85a4f292e27f8407e3dd9632.png";